import { connect } from 'react-redux';
import { closeFilterMenu } from '../../customize/actions_creators';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Collapsible sideBar
const SideBar = ({ filtersVisibility, children, type, closeFilterMenu }) => {
  let typeClass = 'filter-sidebar';
  let sideBarClasses = clsx('sidebar', typeClass);
  let sideBarOverlayClasses = clsx('sidebar-overlay', typeClass);

  let isVisibile = filtersVisibility;
  let toggle = closeFilterMenu;

  const animateDirection = 'left';
  const animationTime = 350;

  const hideSidebar = () => {
    $(`.sidebar.${typeClass}`).animate(
      { [animateDirection]: '-95vw' },
      animationTime
    );
    $(`.sidebar-overlay.${typeClass}`).animate(
      { opacity: 0 },
      animationTime,
      () => {
        $(`.sidebar-overlay.${typeClass}`).css({ display: 'none' });
      }
    );
  };

  const showSidebar = () => {
    $(`.sidebar.${typeClass}`).animate(
      { [animateDirection]: '0' },
      animationTime
    );
    $(`.sidebar-overlay.${typeClass}`).css({ display: 'block' });
    $(`.sidebar-overlay.${typeClass}`).animate(
      { opacity: 1 },
      animationTime,
      () => {}
    );
  };

  if (isVisibile) {
    showSidebar();
  } else {
    hideSidebar();
  }

  return (
    <div className="sidebar-container">
      <div onClick={toggle} className={sideBarOverlayClasses}></div>
      <div className={sideBarClasses}>
        <button
          onClick={toggle}
          className="close-sidebar"
          aria-label="Close filters"
        ></button>
        <div className="sidebar-content">{children}</div>
      </div>
    </div>
  );
};

SideBar.propTypes = {
  type: PropTypes.string.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeFilterMenu: () => dispatch(closeFilterMenu()),
  };
};

let mapStateToPros = (state) => {
  return {
    filtersVisibility: state.filters.filtersVisibility,
  };
};

/**
 * @deprecated
 */
export default connect(mapStateToPros, mapDispatchToProps)(SideBar);
